var Medicine = require('../model/medicine').default

export default {
  name: 'manage-medicine',
  created () {
    this.$store.dispatch('SHOP_SEARCH')
    if (!this.$store.getters.canManage) {
      this.$store.dispatch('CANNOT_USE')
    }
    if (this.$router.currentRoute.query.keep !== 'true') {
      this.clearSearchParams()
    } else {
      if (this.$store.getters.medicineInformationSearchParams) {
        this.shopId = this.$store.getters.medicineInformationSearchParams['shop_id']
        this.facilityId = this.$store.getters.medicineInformationSearchParams['facility_id']
        this.facilityName = this.$store.getters.medicineInformationSearchParams['facility_name']
        this.clinicId = this.$store.getters.medicineInformationSearchParams['clinic_id']
        this.clinicName = this.$store.getters.medicineInformationSearchParams['clinic_name']
        this.careOfficeId = this.$store.getters.medicineInformationSearchParams['care_office_id']
        this.careOfficeName = this.$store.getters.medicineInformationSearchParams['careoffice_name']
        this.patientName = this.$store.getters.medicineInformationSearchParams['patient_name']
      }
    }
    this.search(false)
  },
  data () {
    var sortOrders = {}
    var columns = ['patient-name', 'pdf-name', 'pdf-date']
    columns.forEach(function(key) {
      sortOrders[key] = 1
    })

    return {
      patientName: '',
      facilityId: null,
      facilityName: '',
      clinicId: null,
      clinicName: '',
      careOfficeId: null,
      careOfficeName: '',
      shopId: null,
      searchCallbackFlag: false, // 検索結果フラグ
      columns: columns,
      sortKey: '',
      sortOrders: sortOrders
    }
  },
  computed: {
    uploadCounter () {
      return this.$store.getters.uploadCounter
    },
    uploadErrors () {
      return this.$store.getters.uploadErrors
    },
    medicineInformation () {
      var sortKey       = this.sortKey
      var order         = this.sortOrders[sortKey] || 1
      var medicineInfos = this.$store.getters.medicineInformation
      if (sortKey) {
        medicineInfos = medicineInfos.slice().sort(function(a, b) {
          if (sortKey === 'pdf-date') {
            sortKey = 'sort-pdf-date'
          }

          a = a.attributes[sortKey]
          b = b.attributes[sortKey]
          return (a === b ? 0 : a > b ? 1 : -1) * order
        })
      }
      return medicineInfos
    },
    patients () {
      return this.$store.getters.patients
    },
    facilities () {
      return this.$store.getters.facilities
    },
    careOffices () {
      return this.$store.getters.careOffices
    },
    clinics () {
      return this.$store.getters.clinics
    },
    shops () {
      return this.$store.getters.shops
    },
    nextPage () {
      return this.$store.getters.medicineInformationNextPage
    },
    canManage () {
      return this.$store.getters.canManage
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    loading () {
      return this.$store.getters.apiLoading
    }
  },
  methods : {
    onDragOver : function(event){
      console.log("onDragOver")
      event.preventDefault();
    },
    onDrop : function(event){
      console.log("onDrop")
      // ブラウザ上でファイルを展開する挙動を抑止
      event.preventDefault();

      // ドロップされたファイルのfilesプロパティを参照
      var files = event.dataTransfer.files;
      this.upload(files)
    },
    onFileChange : function(event){
      console.log("onFileChange")

      // ドロップされたファイルのfilesプロパティを参照
      var files = event.target.files;
      this.upload(files)
    },
    upload: function(files){
      this.$store.dispatch('MEDICINE_INFORMATION_UPLOAD_START', {totalCount: files.length})
      for (var i=0; i<files.length; i++) {
        // 一件ずつアップロード
        var formData = new FormData();
        formData.append('medicine_information[pdf_path]', files[i]);

        this.$store.dispatch('MEDICINE_INFORMATION_CREATE', {data: formData})
      }
    },
    search (readMore) {
      var url = null
      var clear = true
      if (readMore) {
        url = this.$store.getters.medicineInformationNextPage
        clear = false
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }

      var data = {'patient_name': this.patientName, 'facility_id': this.facilityId, 'facility_name': this.facilityName, 'clinic_id': this.clinicId, 'clinic_name': this.clinicName, 'care_office_id': this.careOfficeId, 'careoffice_name': this.careOfficeName, 'shop_id': this.shopId}

      this.$store.dispatch('MEDICINE_INFORMATION_SEARCH',  {url: url, clear: clear, data: data, callback: callback})
    },
    sortBy (key) {
      this.sortKey = key
      if ( this.sortOrders[key] > 0) {
        this.sortOrders[key] = -1
      } else {
        this.sortOrders[key] = 1
      }
      console.log("Sorted by " + key + ".")
    },
    isSortKey (key) {
      return key === this.sortKey
    },
    getFacilities: function() {
      this.facilityId = null
      this.$store.dispatch('FACILITY_SEARCH', {data: {'facility_name': this.facilityName, 'shop_id': this.shopId}})
    },
    clearFacilities: function() {
      this.$store.dispatch('FACILITY_CLEAR', 500)
    },
    setSearchFacility: function(facilityId, facilityName) {
      console.log("setFacilityName - facilityName:"+facilityName)
      this.facilityId = facilityId
      this.facilityName = facilityName
    },
    getCareOffices: function() {
      this.careOfficeId = null
      this.$store.dispatch('CARE_OFFICE_SEARCH', {data: {'careoffice_name': this.careOfficeName, 'shop_id': this.shopId}})
    },
    clearCareOffices: function() {
      this.$store.dispatch('CARE_OFFICE_CLEAR', 500)
    },
    setSearchCareOffice: function(careOfficeId, careOfficeName) {
      console.log("setCareOfficeName - careOfficeName:"+careOfficeName)
      this.careOfficeId = careOfficeId
      this.careOfficeName = careOfficeName
    },
    getClinics: function() {
      this.clinicId = null
      this.$store.dispatch('CLINIC_SEARCH', {data: {'clinic_name': this.clinicName, 'shop_id': this.shopId}})
    },
    clearClinics: function() {
      this.$store.dispatch('CLINIC_CLEAR', 500)
    },
    setSearchClinic: function(clinicId, clinicName) {
      console.log("setClinicName - clinicName:"+clinicName)
      this.clinicId = clinicId
      this.clinicName = clinicName
    },
    getShops: function() {
      this.$store.dispatch('SHOP_SEARCH')
    },
    getPDF (url) {
      console.log('getPDF!')
      this.$store.dispatch('MEDICINE_INFORMATION_PDF',  {url: url}).then(() => {
        console.log('Progressing getPDF...')

        var blob = new Blob([ this.$store.getters.medicineInformationPDF], {type: 'application/pdf'})
        if (window.navigator.msSaveBlob) {
          window.navigator.msSaveOrOpenBlob(blob, "yakujo.pdf");
        } else if (window.URL && window.URL.createObjectURL) {
          var fileURL = window.URL.createObjectURL(blob)
          console.log('URL: ' + fileURL)
          window.open(fileURL)
        }
      })
    },
    deleteConfirm: function(medicineInformationId) {
      console.log("medicineInformationId:" + medicineInformationId)
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('MEDICINE_INFORMATION_DELETE', {'medicineInformationId': medicineInformationId})
      }
    },
    clearSearchParams: function() {
      this.shopId = null
      if (this.$store.getters.canManage && !this.shopId) {
        this.shopId = this.$store.getters.currentShopId
      }
      this.facilityId = null
      this.facilityName = ''
      this.clinicId = null
      this.clinicName = ''
      this.careOfficeId = null
      this.careOfficeName = ''
      this.PatientName = ''

      this.$store.dispatch('CLEAR_MEDICINE_INFORMATION_SEARCH_PARAMS')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/manage-medicine.js